import { Field } from "@/components/tool-kit/primitives";
import { INPUT_MONO, SELECT } from "@/components/tool-kit/styles";

export interface UnitChoice {
  value: string;
  label: string;
}

/**
 * A number and its unit side by side. When `solved` is true the quantity is the answer:
 * only the unit menu shows, so the reader can pick the unit the result is written in.
 *
 * `id` prefixes both controls; `unitLabel` is the accessible name of the unit menu.
 */
export function QuantityInput({
  id,
  label,
  hint,
  value,
  onValueChange,
  unit,
  onUnitChange,
  units,
  unitLabel,
  solved = false,
  placeholder,
}: {
  id: string;
  label: string;
  hint?: string;
  value: string;
  onValueChange: (value: string) => void;
  unit: string;
  onUnitChange: (unit: string) => void;
  units: readonly UnitChoice[];
  unitLabel: string;
  solved?: boolean;
  placeholder?: string;
}) {
  return (
    <Field hint={hint} id={solved ? `${id}-unit` : id} label={label}>
      <div className="flex gap-2">
        {solved ? null : (
          <input
            className={INPUT_MONO}
            id={id}
            inputMode="decimal"
            onChange={(event) => onValueChange(event.target.value)}
            placeholder={placeholder}
            value={value}
          />
        )}
        <select
          aria-label={solved ? undefined : unitLabel}
          className={`${SELECT} ${solved ? "" : "w-32 shrink-0"}`}
          id={`${id}-unit`}
          onChange={(event) => onUnitChange(event.target.value)}
          value={unit}
        >
          {units.map((choice) => (
            <option key={choice.value} value={choice.value}>
              {choice.label}
            </option>
          ))}
        </select>
      </div>
    </Field>
  );
}
